import { z } from "zod";

export const appointmentActionTypeSchema = z.enum([
	"confirm",
	"cancel",
	"reschedule",
]);
export type AppointmentActionType = z.infer<typeof appointmentActionTypeSchema>;

/** Body for POST /actions/:token/reschedule — the new slot the patient picked. */
export const rescheduleActionInputSchema = z.object({
	scheduled_at: z.string().datetime(),
});
export type RescheduleActionInput = z.infer<typeof rescheduleActionInputSchema>;

export interface ActionTokenInfo {
	action: AppointmentActionType;
	used: boolean;
	expired: boolean;
	used_at: string | null;
	appointment: {
		id: string;
		scheduled_at: string;
		duration_minutes: number;
		status: string;
		title: string | null;
		service_name: { ar: string; en?: string } | null;
		is_video: boolean;
		video_room_url: string | null;
		/** Whether the appointment is still in a state a patient may reschedule
		 *  from (booked/confirmed/arrived/no_show). Drives the reschedule UI. */
		reschedulable: boolean;
	};
	patient: {
		full_name: string;
		preferred_language: "ar" | "en";
	};
	clinic: {
		name: { ar: string; en?: string };
		phone: string | null;
	};
}

export interface ActionExecuteResult {
	action: AppointmentActionType;
	appointment_id: string;
	status: string;
	executed_at: string;
}
